/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiV0AbsenceEntryRejectAbsenceEntryPost$Params {
  id?: string;
  message?: string;
}

export function apiV0AbsenceEntryRejectAbsenceEntryPost(http: HttpClient, rootUrl: string, params?: ApiV0AbsenceEntryRejectAbsenceEntryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV0AbsenceEntryRejectAbsenceEntryPost.PATH, 'post');
  if (params) {
    rb.query('id', params.id, {});
    rb.query('message', params.message, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV0AbsenceEntryRejectAbsenceEntryPost.PATH = '/api/v0/absenceEntry/rejectAbsenceEntry';
